var map = {
	"./action_img.png": 104,
	"./background.png": 308,
	"./banner_shap.png": 309,
	"./cloud-computing.png": 310,
	"./cloud_01.png": 105,
	"./cloud_02.png": 106,
	"./cloud_03.png": 107,
	"./cloud_04.png": 108,
	"./cloud_05.png": 109,
	"./cloud_06.png": 110,
	"./crm_img1.jpg": 311,
	"./crm_img2.jpg": 312,
	"./crm_img3.jpg": 313,
	"./erp_dashboard.jpg": 111,
	"./erp_icon1.png": 314,
	"./erp_icon2.png": 315,
	"./erp_icon3.png": 316,
	"./erp_icon4.png": 317,
	"./erp_icon5.png": 318,
	"./erp_icon6.png": 319,
	"./growth.png": 320,
	"./img/01.png": 112,
	"./img/02.png": 113,
	"./img/03.png": 114,
	"./img/04.png": 115,
	"./img/05.png": 116,
	"./img/06.png": 117,
	"./img/07.png": 118,
	"./img/08.png": 119,
	"./img/09.png": 120,
	"./img/10.png": 121,
	"./img/11.png": 122,
	"./img/12.png": 123,
	"./img/13.png": 124,
	"./img/14.png": 125,
	"./img/15.png": 126,
	"./img/16.png": 127,
	"./img/17.png": 128,
	"./img/18.png": 129,
	"./img/19.png": 130,
	"./img/20.png": 131,
	"./quote.png": 321,
	"./rocket.png": 132,
	"./settings1.png": 322,
	"./shape.png": 323,
	"./testimonial_img.jpg": 324,
	"./testimonial_img2.jpg": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;